
export const PageHelper = {
    GetSkipCount,
    GetTotalCountToPages,
    CountPreviousPageNumber
}

function GetSkipCount(pageSize, pageNo) {
    return (pageNo - 1) * pageSize;
}

function GetTotalCountToPages(pageSize, totalCount) {
    return Math.ceil(totalCount / pageSize);
}

function CountPreviousPageNumber(currentPage, totalCount, pageSize, totalPage) {
    let newTotalCount = totalCount - 1;
    if (newTotalCount <= 0)
        return 1;

    let newTotalPage = GetTotalCountToPages(pageSize, newTotalCount);
    if (newTotalPage == totalPage)
        return currentPage;

    return (currentPage - 1) > 0 ? currentPage - 1 : 1;
}